export const TABS = {
	SOLUTIONS: 'solutions',
	ABOUT: 'about',
	SMART_SEARCH: 'smart-search',
	CONTACT: 'contact',
  COUNTRY: 'country',
  MOBILECOUNTRY: 'mobile-country'
};

// Configuration constants
export const DRAWER_TRANSITION_TIMEOUT = 350;
export const DEFAULT_COUNTRY = 'United States';
export const DEFAULT_LOCALE = 'en-US';

export const CONTACT_LINKS = [
  {
    label: 'Contact us',
    // href: 'mailto:adpmarketplace@adp.com',
  },
  {
    label: 'Newsletter',
    href: 'https://info.adp.com/subscribe-128833',
  },
  {
    label: 'Blog',
    href: 'https://www.adp.com/spark.aspx',
  },
];

export const INDUSTRIES = [ 
    {name : 'Restaurant & Hospitality', attributeId: 9512},
    {name : 'Manufacturing', attributeId: 9516},
    {name : 'Professional & Technical Services', attributeId: 9520},
    {name : 'Construction', attributeId: 9524},
    {name : 'Financial Services', attributeId: 9528},
    {name : 'Retail', attributeId: 9532},
    {name : 'Health Care', attributeId: 9536},
    {name : 'Government & Education', attributeId: 9540},
    {name : 'Nonprofit & Social Services', attributeId: 9544},
    {name : 'Other'}
  ]


  export const MARKETPLACE_LINKS = [
    { label: 'About Marketplace', path: '/pages/why-marketplace', internal: true },
    { label: 'API Central', path: '/pages/solutions/api-central', internal: true },
    { label: 'Apps Home', path: '/en-US/home', internal: true },
    { label: 'Partners', path: 'https://partners.adp.com/', internal: false },
    { label: 'Developers', path: 'https://developers.adp.com/', internal: false },
    { label: 'About ADP', path: 'https://www.adp.com/', internal: false }
  ];


  export const SOCIAL_LINKS = [
    { icon: 'brand-facebook', alt: 'Facebook', href: 'https://www.facebook.com/AutomaticDataProcessing' },
    { icon: 'brand-youtube', alt: 'YouTube', href: 'https://www.youtube.com/user/adp' },
    { icon: 'brand-twitter', alt: 'Twitter', href: 'https://x.com/ADP' },
    { icon: 'brand-linkedin', alt: 'LinkedIn', href: 'https://www.linkedin.com/company/adp/' }
  ];

export const events = {
  // Event Names
  EVENT_NAMES: {
    HEADER_STOREFRONT_NAVIGATION: 'header_storefront_navigation',
    FOOTER_NAVIGATION_BAR: 'footer_navigation_bar',
    FOOTER_STOREFRONT_NAVIGATION: 'footer_storefront_navigation',
    FOOTER_LEGAL_LINKS_CLICK: 'footer_legal_links_click',
    HEADER_MENU: 'header_menu',
    HEADER_SUBMENU: 'header_submenu',
    HEADER_SEARCH: 'header_search',
    HEADER_CONTACT_US: 'header_contact_us',
    HEADER_USERNAME_CLICK: 'header_username_click',
    ADP_LOGO: 'adp_logo',
    HEADER_LOGIN: 'header_login',
    HEADER_CART: 'header_cart',
    SCROLL_25: 'scroll_25',
    SCROLL_50: 'scroll_50',
    SCROLL_75: 'scroll_75',
    SCROLL_90: 'scroll_90',
    HEADER_SMART_SEARCH: 'header_smart_search',
    HEADER_ABOUT: 'header_about',
    HEADER_AI_SOLUTIONS: 'header_ai_solutions',
    // My Apps events
    MYAPPS_MENU_CLICK: 'myapps_menu_click',
  },
  
  // Event Categories
  EVENT_CATEGORIES: {
    HEADER_STORE_NAVIGATION: 'header_store_navigation',
    FOOTER_STOREFRONT_NAVIGATION: 'footer_storefront_navigation',
    FOOTER_LEGAL_LINKS_CLICK: 'footer_legal_links_click',
    HEADER_MENU: 'header_menu',
    HEADER_SEARCH: 'header_search',
    HEADER_CONTACT_US: 'header_contact_us',
    HEADER_USERNAME_CLICK: 'header_username_click',
    ADP_LOGO: 'adp_logo',
    LOGIN_CTA: 'login_cta',
    HEADER_CART: 'header_cart',
    HEADER_SMART_SEARCH: 'header_smart_search',
    HEADER_ABOUT: 'header_about',
    HEADER_AI_SOLUTIONS: 'header_ai_solutions',
    // My Apps categories
    MYAPPS_NAVIGATION: 'myapps_navigation',
  },
  
  // Event Actions
  EVENT_ACTIONS: {
    COUNTRY_DROPDOWN_CLICK: 'country_dropdown_click',
    COUNTRY_SELECTION: 'country_selection',
    COUNTRY_CLICK: 'country_click',
    LINK_CLICK: 'link_click',
    CLICK: 'click',
    APP_ID_CLICK: 'app_id_click',
    CATEGORY_CTA_CLICK: 'category_cta_click',
    APP_REVIEWS_CLICK: 'app_reviews_click',
    INITIATE: 'initiate',
    COMPLETE: 'complete',
    CLOSE: 'close',
    TRIGGER_CTA_CLICK: 'trigger_cta_click',
    SUBMIT_CLICK: 'submit_click',
    CANCEL_CLICK: 'cancel_click',
    SUBMISSION_SUCCESS: 'submission_success',
    SUBMISSION_FAIL: 'submission_fail',
    DIALOGUE_VIEW: 'dialogue_view',
    CART_CLICK: 'cart_click',
    CART_DIALOGUE_CLICK: 'cart_dialogue_click',
  }
}

export const APP_ROUTES = {
  '/': 'Home Page', 
  '/home': 'Home Page',
  '/resources-insights/employee-experience-solutions': 'Employee Experience Solutions',
  '/search': 'Global Search', 
  // '/smart-search': 'Smart Search',
  '/myapps': 'My Apps',
  '/login': null,
  '/logout': null,
  '/listing': 'Listing Page',
  '/checkout': 'Checkout Page',
  '/apps': 'App Details',
  '/pages/solutions/api-central': 'API Central',
};
